import {GET_CURRENT_BETFAIR_ODDS, GET_CURRENT_PINNACLE_ODDS} from "../../../constants/OddsConstants";
import {GeneralAction} from "../../../@types/actions";

export const GetCurrentOddsAction = (bookmaker: number): GeneralAction<number> => ({
    type: bookmaker === 2 ? GET_CURRENT_BETFAIR_ODDS : GET_CURRENT_PINNACLE_ODDS,
    payload: bookmaker
});

